import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faClock } from '@fortawesome/free-solid-svg-icons';
import Button from '../button/Button';
import './Dialog.scss';

const Dialog = ({
  messages,
  date,
  positiveButtonText,
  negativeButtonText,
  onPositiveButtonClick,
  onNegativeButtonClick,
  hideNegativeButton,
  icon = 'exclamation',
  opacity = false,
}) => (
  <div className={classnames('dialog', opacity ? 'transparent' : 'not-transparent')}>
    <div className="dialog-container">
      <div className="dialog-body">
        <div className="warning">
          <FontAwesomeIcon icon={icon === 'exclamation' ? faExclamationCircle : faClock} size="lg" />
        </div>
        <div className="dialog-text">
          {
              !!messages && messages.length > 0 && messages.map((message, index) => <div key={index} className="message">{message}</div>)
            }
        </div>
      </div>
      {
          !!date && <div className="date">{date}</div>
        }
      <Button
        type="button"
        className="positive-button"
        text={positiveButtonText}
        onClick={onPositiveButtonClick}
      />
      {
          !hideNegativeButton && (
            <div
              className="cancel-booking-container negative-button"
              onClick={onNegativeButtonClick}
            >
              <div className="cancel-booking">{negativeButtonText}</div>
            </div>
          )
        }
    </div>
  </div>
);

Dialog.propTypes = {
  messages: PropTypes.array.isRequired,
  date: PropTypes.string,
  positiveButtonText: PropTypes.string.isRequired,
  negativeButtonText: PropTypes.string,
  onPositiveButtonClick: PropTypes.func.isRequired,
  onNegativeButtonClick: PropTypes.func,
  hideNegativeButton: PropTypes.bool,
  icon: PropTypes.oneOf(['exclamation', 'timer']),
  opacity: PropTypes.bool,
};

export default Dialog;
